/**
 * Autocomplete Comune di Nascita
 *
 * Gestisce il campo autocomplete per la ricerca del comune di nascita italiano.
 * - Per nazionalità IT: chiama l'API /comuni-italiani/search e mostra un dropdown
 * - Per nazionalità non-IT: campo libero (testo semplice, senza autocomplete)
 *
 * Valori salvati (campi hidden):
 *   #birth_city         → nome del comune
 *   #birth_province     → sigla provincia (solo per comuni italiani)
 *   #birth_postal_code  → CAP (solo se disponibile nel dataset)
 *
 * Tastiera: ↓↑ per navigare nel dropdown, Enter per selezionare, Esc per chiudere
 */

(function () {
    'use strict';

    var API_URL = (typeof APP_ROOT !== 'undefined' ? APP_ROOT : '') +
                  '/api/' + (typeof LOCALE !== 'undefined' ? LOCALE : 'it') +
                  '/v1/comuni-italiani/search';

    var DEBOUNCE_DELAY = 250; // ms

    var inputVisible   = document.getElementById('birth_city_autocomplete');
    var hiddenCity     = document.getElementById('birth_city');
    var hiddenProvince = document.getElementById('birth_province');
    var hiddenPostal   = document.getElementById('birth_postal_code');
    var dropdown       = document.getElementById('birth_city_dropdown');
    var nationalityEl  = document.getElementById('nationality');

    if (!inputVisible || !hiddenCity || !dropdown) {
        return; // campo non presente in questa pagina
    }

    var debounceTimer = null;
    var lastQuery     = '';
    var selectedValue = hiddenCity.value || '';

    // ------------------------------------------------------------------
    // Utilità
    // ------------------------------------------------------------------

    function isItalian() {
        return !nationalityEl || nationalityEl.value === 'IT' || nationalityEl.value === '';
    }

    function escapeHtml(str) {
        var d = document.createElement('div');
        d.appendChild(document.createTextNode(str || ''));
        return d.innerHTML;
    }

    // ------------------------------------------------------------------
    // Dropdown
    // ------------------------------------------------------------------

    function showDropdown(items) {
        dropdown.innerHTML = '';

        if (!items || items.length === 0) {
            dropdown.style.display = 'none';
            return;
        }

        items.forEach(function (item) {
            var li = document.createElement('li');
            li.className  = 'comuni-dropdown__item';
            li.tabIndex   = 0;          // ← rende l'elemento focusable con tastiera
            li.setAttribute('role', 'option');

            // Etichetta: Nome (PR) – CAP
            var label = '<span class="comuni-dropdown__name">' + escapeHtml(item.name) + '</span>';
            if (item.province) {
                label += ' <span class="comuni-dropdown__province">(' + escapeHtml(item.province) + ')</span>';
            }
            if (item.postal_code) {
                label += ' <span class="comuni-dropdown__cap">– ' + escapeHtml(item.postal_code) + '</span>';
            }
            li.innerHTML = label;

            li.addEventListener('mousedown', function (e) {
                e.preventDefault(); // evita che l'input perda il focus prima del click
                selectComune(item);
            });

            li.addEventListener('keydown', function (e) {
                handleDropdownKeydown(e, item);
            });

            dropdown.appendChild(li);
        });

        dropdown.style.display = 'block';
    }

    function hideDropdown() {
        dropdown.style.display = 'none';
        dropdown.innerHTML = '';
    }

    function selectComune(item) {
        inputVisible.value   = item.name;
        hiddenCity.value     = item.name;
        hiddenProvince.value = item.province    || '';
        hiddenPostal.value   = item.postal_code || '';
        selectedValue        = item.name;
        hideDropdown();
        inputVisible.focus();
    }

    // ------------------------------------------------------------------
    // Navigazione tastiera nel dropdown
    // ------------------------------------------------------------------

    function handleDropdownKeydown(e, item) {
        var items   = Array.prototype.slice.call(dropdown.querySelectorAll('.comuni-dropdown__item'));
        var current = document.activeElement;
        var idx     = items.indexOf(current);

        switch (e.key) {
            case 'Enter':
            case ' ':
                e.preventDefault();
                selectComune(item);
                break;

            case 'ArrowDown':
                e.preventDefault();
                if (idx < items.length - 1) {
                    items[idx + 1].focus();
                }
                break;

            case 'ArrowUp':
                e.preventDefault();
                if (idx > 0) {
                    items[idx - 1].focus();
                } else {
                    inputVisible.focus();
                }
                break;

            case 'Escape':
                hideDropdown();
                inputVisible.focus();
                break;

            case 'Tab':
                hideDropdown();
                break;
        }
    }

    // ------------------------------------------------------------------
    // API call
    // ------------------------------------------------------------------

    function fetchComuni(query) {
        var xhr = new XMLHttpRequest();
        xhr.open('GET', API_URL + '?q=' + encodeURIComponent(query), true);
        xhr.setRequestHeader('Accept', 'application/json');
        xhr.onload = function () {
            if (xhr.status === 200) {
                try {
                    var data = JSON.parse(xhr.responseText);
                    showDropdown(data);
                } catch (e) {
                    hideDropdown();
                }
            } else {
                hideDropdown();
            }
        };
        xhr.onerror = function () {
            hideDropdown();
        };
        xhr.send();
    }

    // ------------------------------------------------------------------
    // Modalità: italiano vs. estero
    // ------------------------------------------------------------------

    function enableAutocomplete() {
        inputVisible.placeholder = inputVisible.dataset.placeholderIt ||
            (window.ComuniLabels ? window.ComuniLabels.placeholder : 'Cerca comune di nascita...');
    }

    function disableAutocomplete() {
        hideDropdown();
        inputVisible.placeholder = inputVisible.dataset.placeholderFree ||
            (window.ComuniLabels ? window.ComuniLabels.placeholderFree : 'Inserisci il comune di nascita');
        // Svuota provincia e CAP perché non siamo più in modalità italiana
        hiddenProvince.value = '';
        hiddenPostal.value   = '';
    }

    function syncToHidden() {
        hiddenCity.value = inputVisible.value;
        // Se l'utente ha modificato manualmente il testo, svuota provincia/CAP
        if (inputVisible.value !== selectedValue) {
            hiddenProvince.value = '';
            hiddenPostal.value   = '';
            selectedValue        = '';
        }
    }

    // ------------------------------------------------------------------
    // Event listeners sull'input principale
    // ------------------------------------------------------------------

    inputVisible.addEventListener('input', function () {
        syncToHidden();

        if (!isItalian()) {
            return;
        }

        var q = inputVisible.value.trim();
        if (q === lastQuery) {
            return;
        }
        lastQuery = q;

        clearTimeout(debounceTimer);
        if (q.length < 2) {
            hideDropdown();
            return;
        }

        debounceTimer = setTimeout(function () {
            fetchComuni(q);
        }, DEBOUNCE_DELAY);
    });

    inputVisible.addEventListener('blur', function () {
        // Piccolo ritardo: permette il mousedown sul dropdown prima di nasconderlo
        setTimeout(function () {
            // Chiudi solo se il focus non è finito su un elemento del dropdown
            if (!dropdown.contains(document.activeElement)) {
                hideDropdown();
            }
        }, 150);
    });

    inputVisible.addEventListener('keydown', function (e) {
        switch (e.key) {
            case 'ArrowDown': {
                e.preventDefault();
                var first = dropdown.querySelector('.comuni-dropdown__item');
                if (first) {
                    first.focus();
                }
                break;
            }
            case 'Escape':
                hideDropdown();
                break;

            case 'Enter':
                // Se c'è un solo risultato nel dropdown, selezionalo direttamente
                var items = dropdown.querySelectorAll('.comuni-dropdown__item');
                if (items.length === 1) {
                    e.preventDefault();
                    items[0].dispatchEvent(new MouseEvent('mousedown', { bubbles: true }));
                }
                break;
        }
    });

    // ------------------------------------------------------------------
    // Aggiorna modalità al cambio nazionalità
    // ------------------------------------------------------------------

    if (nationalityEl) {
        nationalityEl.addEventListener('change', function () {
            if (isItalian()) {
                enableAutocomplete();
            } else {
                disableAutocomplete();
            }
            // Reset del campo quando cambia nazionalità
            inputVisible.value   = '';
            hiddenCity.value     = '';
            hiddenProvince.value = '';
            hiddenPostal.value   = '';
            selectedValue        = '';
            lastQuery            = '';
            hideDropdown();
        });
    }

    // ------------------------------------------------------------------
    // Inizializzazione
    // ------------------------------------------------------------------

    if (isItalian()) {
        enableAutocomplete();
    } else {
        disableAutocomplete();
    }

    // Se il campo ha già un valore (es. modifica iscrizione) non avviare la ricerca
    if (hiddenCity.value) {
        inputVisible.value = hiddenCity.value;
        selectedValue      = hiddenCity.value;
    }

}());
